import React from "react";

const B2BFooter = () => {
  return (
    <footer className="b2b-footer">
      <div className="b2b-footer-inner">
        <div className="b2b-footer-bottom">
          © 2025 The Local Intent Company. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default B2BFooter;
